import { DomainStatus } from '../enums/domain-status.enum';
import { DomainVerificationType } from '../enums/domain-verification-type.enum';
import { BackendDomainRegistrationUrl } from './domain-registration-url';

export const CORPORATE_DOMAIN_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.corporate.domain.v1+json';
export const CORPORATE_DOMAIN_COLLECTION_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.corporate.domain.collection.v1+json';

export class Domain {
  public id: string;
  public domain: string;
  public status: DomainStatus;
  public updatedAt: Date;
  public verificationEmail: string;
  public enterpriseId: string;
  public enterpriseName: string;
  public verificationType: DomainVerificationType;

  public get canBeVerified(): boolean {
    return this.status === DomainStatus.Pending;
  }

  constructor(backEndDomain?: BackEndDomain) {
    if (backEndDomain) {
      this.id = backEndDomain.id;
      this.domain = backEndDomain.domain;
      this.status = backEndDomain.status;
      this.updatedAt = backEndDomain.updated_at ? new Date(backEndDomain.updated_at) : null;
      this.verificationEmail = backEndDomain.verification_email;
      this.enterpriseId = backEndDomain.enterprise_code;
      this.enterpriseName = backEndDomain.enterprise_name;
      this.verificationType = backEndDomain.verification_type;
    }
  }

  public toBackEnd(): BackEndDomain {
    return {
      id: this.id,
      domain: this.domain,
      status: this.status,
      updated_at: this.updatedAt ? this.updatedAt.toString() : null,
      verification_email: this.verificationEmail,
      enterprise_code: this.enterpriseId,
      enterprise_name: this.enterpriseName,
      verification_type: this.verificationType,
    };
  }

  public toBackEndPatch(): BackEndDomainPatch {
    return {
      id: this.id,
      status: this.status,
    };
  }

  public clone(): Domain {
    const c = new Domain();
    c.id = this.id;
    c.domain = this.domain;
    c.status = this.status;
    c.updatedAt = this.updatedAt ? new Date(this.updatedAt) : null;
    c.verificationEmail = this.verificationEmail;
    c.enterpriseId = this.enterpriseId;
    c.enterpriseName = this.enterpriseName;
    c.verificationType = this.verificationType;
    return c;
  }
}

export interface BackEndDomain {
  id: string;
  domain: string;
  status: DomainStatus;
  updated_at: string;
  verification_email: string;
  enterprise_code: string;
  enterprise_name: string;
  verification_type: DomainVerificationType;
}

export interface BackEndDomainPatch {
  id: string;
  status: DomainStatus;
}

export interface BackEndDomainCollection {
  domains: BackendDomainRegistrationUrl[];
}
